import * as React from 'react';


export default class Save extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs></defs>
        <g id="exzeo_2.x_icon_set" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-276.000000, -180.000000)" opacity="0.600000024">
            <g id="Group-60" transform="translate(276.000000, 180.000000)" stroke="#231F20">
                <g id="Group-59" transform="translate(1.000000, 2.000000)">
                    <g id="Page-1">
                        <path d="M13.85755,3.7097375 L13.85755,12.6268625 C13.85755,13.0223625 13.536425,13.3434875 13.140925,13.3434875 L1.1543,13.3434875 C0.757925,13.3434875 0.437675,13.0223625 0.437675,12.6268625 L0.437675,1.1538625 C0.437675,0.7583625 0.757925,0.4372375 1.1543,0.4372375 L10.30155,0.4372375 C10.4783,0.4372375 10.648925,0.5028625 10.780175,0.6218625 L13.620425,3.1768625 C13.770925,3.3124875 13.85755,3.5067375 13.85755,3.7097375 Z" id="Stroke-1"></path>
                        <path d="M10.275475,13.34375 L3.38485,13.34375 L3.38485,8.736 C3.38485,8.5925 3.501225,8.477 3.644725,8.477 L10.0156,8.477 C10.1591,8.477 10.275475,8.5925 10.275475,8.736 L10.275475,13.34375 Z" id="Stroke-3"></path>
                        <path d="M8.2247375,4.5390625 C8.2247375,5.3090625 7.5999875,5.9338125 6.8299875,5.9338125 C6.0599875,5.9338125 5.4352375,5.3090625 5.4352375,4.5390625 C5.4352375,3.7690625 6.0599875,3.1443125 6.8299875,3.1443125 C7.5999875,3.1443125 8.2247375,3.7690625 8.2247375,4.5390625 Z" id="Stroke-5"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
